import React from 'react';
import {SvgIcon} from "@mui/material";

const InlineTipIcon = ({fgColor = "white", bgColor = "black", bgOpacity = 1}) => {
    return (
        <SvgIcon>
            <svg focusable={false} fill={bgColor}>
                <path
                    d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8m1 14h-2v-2h2zm0-3h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5"
                    opacity={bgOpacity}
                />
            </svg>
            <svg focusable={false} fill={fgColor}>
                <path
                    d="M11 16h2v2h-2zm1-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"
                />
            </svg>
        </SvgIcon>
    );
};

export default InlineTipIcon;